export const odluka_o_neplacenom_dopustu = {
    templateId: 31,
    category: 3,
    templateTitle: 'Odluka o neplaćenom dopustu',
    templateDescription: `<p>Poslodavac može (ali i ne mora) na zahtjev radnika odobriti radniku neplaćeni dopust pri čemu prava i obveze iz radnog odnosa miruju.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Poslodavac može, u slučaju potrebe radnika, na zahtjev radnika odobriti radniku neplaćeni dopust.</p>
    <p>Budući da Zakon o radu nije odredio niti kriterije, niti trajanje neplaćenog dopusta, poslodavac samostalno odlučuje o navedenom pravu.</p>
    <p>Radnik može koristiti neplaćeni dopust samo ako je dobio odobrenje poslodavca.</p>
    <p>Zakonom o radu nisu propisani razlozi zbog kojih se može odobriti neplaćeni dopust, a nisu niti propisana ograničenja trajanja neplaćenog dopusta, stoga neplaćeni dopust može trajati onoliko koliko se radnik i poslodavac dogovore.</p>
    <p>Za vrijeme neplaćenog dopusta radnik nema pravo na plaću i poslodavac ga <strong>može odjaviti ​</strong> s obveznih osiguranja (mirovinskog i zdravstvenog), pri čemu prava i obveze iz radnog odnosa miruju. Dakle, radnik će za vrijeme neplaćenog dopusta biti zdravstveno i mirovinski neosiguran.</p>
    <p>Ipak, ukoliko tako odluči, poslodavac <strong>može radnika ne odjaviti s mirovinskog i zdravstvenog osiguranja</strong> te za razdoblje korištenja neplaćenog dopusta obračunavati (i uplaćivati) obvezne doprinose na iznos najniže osnovice za obračun doprinosa, ali mu za to razdoblje neće biti u obvezi isplatiti plaću. Navedena mogućnost je predviđena Pravilnikom o doprinosima.</p>
    <p>Posebna vrste neplaćenog dopusta odnosi se na pravo majke ili oca da po isteku rodiljnog dopusta do godine dana djeteta, koriste pravo na neplaćeni dopust do treće godine djetetova života. Navedeno pravo uređeno je Zakonom o rodiljnim i roditeljskim potporama.</p>
    <p>Radnik (otac ili majka) koji koristi pravo na naplaćeni dopust do treće godine života djeteta u skladu s posebnim propisom, može otkazati ugovor o radu izvanrednim otkazom.</p>
    <p>Nakon isteka mirovanja radnog odnosa do treće godine života djeteta u skladu, radnik koji je koristio neplaćeni dopust ima pravo povratka na poslove na kojima je radio prije korištenja toga prava, u roku od mjesec dana od dana kada je poslodavca obavijestio o prestanku korištenja toga prava.</p>
    <p>Poslodavac jedan primjerak odluke o mirovanju radnog odnosa zaposlenog roditelja do treće godine djetetova života obvezno dostavlja Hrvatskom zavodu za zdravstveno osiguranje, radi evidencije.</p>
    <h5>NAJČEŠĆE GREŠKE</h5>
    <p><strong>- Netočno evidentiranje neplaćenog dopusta u evidenciji radnog vremena</strong></p>
    <p>Pojašnjenje: sukladno Pravilniku o sadržaju i načinu vođenja evidencije o radnicima neplaćeni dopust se evidentira kao vrijeme nenazočnosti na radu.</p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o radu, Zakon o rodiljnim i roditeljskom potporama, Pravilnik o doprinosima.</p>
  `,
    sides: [
        {
            prefix: 'Na temelju Zakona o radu,',
            signature: 'Za Poslodavca:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Poslodavac),',
        }
    ],

    headline: '​donosi sljedeću',
    title: 'ODLUKA O ODOBRENJU KORIŠTENJA NEPLAĆENOG DOPUSTA',
    noArticleNumbers: true,

    articles: [
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: true,
                    parts: [
                        {type: 'text', content: 'Radniku'},
                        { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
                        { type: "text", content: "," },
                        { type: 'text', content: 'iz',},
                        { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
                        { type: 'text', content: ',' },
                        { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
                        { type: "text", content: "," },
                        { type: 'text', content: 'OIB:' },
                        { type: "input",  required: true,},
                        {type: 'text', content: ', (u daljnjem tekstu: Radnik), odobrava se korištenje neplaćenog dopusta u razdoblju od'},
                        {type: 'input', value: '', required: true},
                        {type: 'text', content: 'do'},
                        {type: 'input', value: '', required: true},
                        {type: 'text', content: 'godine, radi'},
                        {type: 'input', value: '', required: true},
                        {help: 'Navesti osnovu zbog koje se plaćeni dopust odobrava (sklapanje braka, rođenje djeteta, teža bolest, smrt člana uže obitelji).'},
                    ],
                }],
            value: '',
        },
        {
          title: '------------------------------------------------------Obrazloženje------------------------------------------------------',
          mandatory: true,
            dummy: true, 
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    dummy: true,
                    parts: [
                        {type: 'text', content: 'Radnik je dana'},
                        {type: 'input', value: '', required: true},
                        {type: 'text', content: 'godine podnio Poslodavcu zahtjev za korištenje neplaćenog dopusta.'}],
                }],
            value: '',
        },
        {
            title: '',
            mandatory: true,
            dummy: true,
            statements:   [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: "Poslodavac je razmotrio zahtjev Radnika te je utvrdio da je isti ispunjava sve propisane uvjete, stoga je odlučeno kao u izreci ove Odluke.",
                    value: '',
                }],
        },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  {
                    type: "text",
                    content: "U"
                  },
                  {
                    type: "input",
                    value: "",
                    placeholder: "Upišite mjesto.",
                    required: true,
                  },
                  {
                    type: "text",
                    content: ", dana"
                  },
                  {
                    type: "date",
                    value: new Date(),
                    required: true
                  },
                  {
                    type: "text",
                    content: "godine."
                  }
                ]
              },
            ]
          },
          {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
          },
          {
            static: true,
            mandatory: false,
            type: 4, 
            statements: [
              {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Dostaviti:\r\n1) Radniku\r\n2) Kadrovska služba',
                help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
              }
            ]
          },
          {
            static: true,
            mandatory: true,
            type: 4, 
            statements: [
              {
                type: 'text',
                mandatory: true,
                editable: true,
                help: 'Ako postupak dostave nije uređen kol. ug., sporazumom između radničkog vijeća i poslodavca ili pravilnikom o radu, primjenjuju se odredbe o dostavi određene parničnim postupkom. U tom slučaju, otkaz se može dostaviti prep. pošt. pošiljkom s povr. ili osobno, na radnom mjestu, no ukoliko radnik odbija primiti odluku, navedeno odbijanje može se pisano konstatirati uz potpis dva svjedoka. Otkaz se može dostaviti i putem j. bilježnika.',
                content: 'Potvrđujem primitak Odluke dana _______________ godine.\r\n\r\nPotpis Radnika: ____________________\r\n\r\n',
              },
            ]
          },
        ],
      };


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/31_olduka_o_neplacenom_dopustu.ts